import Skeleton from "react-loading-skeleton";

export default function SkeletonSuggestedResultList() {
	return (
		<>
			<Skeleton width={"100%"} />
			<Skeleton width={"60%"} />
			<Skeleton width={"80%"} />
		</>
	);
}
